import { PureComponent } from 'react';
import { connect } from 'react-redux';

import Log from '../utils/Log';
import { getCurrentProvider } from '../utils/Utils';
import { STATUSES, SUPPORTED_PROVIDERS, MILLISECONDS_IN_A_SECOND } from '../config/constants';
import { initContract } from '../config/blockchain';
import { fetchWeb3, setMyWalletAddress, setStatus } from '../redux/actions/web3Actions';

class Web3Provider extends PureComponent {
  checkUserAccount() {
    if (this.props.web3.currentProvider) { // Is provider
      if (this.isSupportedProvider()) { // Is supported provider
        // FIXME: On first launch of Google Chrome, getAccounts doesn't callback but refreshing page works?
        this.props.web3.eth.getAccounts((error, accounts) => {
          if (accounts > 0) {
            const address = accounts[0];

            if (address !== this.props.myWalletAddress) {
              if (this.props.myWalletAddress !== null) {
                Log.info('Account changed to: ' + address);
              }

              this.props.setStatus(STATUSES.AVAILABLE);
              this.props.setMyWalletAddress(address);
            }
          } else {
            this.props.setStatus(STATUSES.LOCKED);
            this.props.setMyWalletAddress(null);
          }
        });
      } else { // No supported provider
        this.props.setStatus(STATUSES.FALLBACK);
        this.props.setMyWalletAddress(null);
      }
    } else { // No provider
      this.props.setStatus(STATUSES.UNKNOWN);
      this.props.setMyWalletAddress(null);
    }

    this.setUserTimer();
  }

  isSupportedProvider() {
    const currentProvider = getCurrentProvider(this.props.web3);
    return SUPPORTED_PROVIDERS.includes(currentProvider);
  }

  setUserTimer() {
    // From: https://github.com/MetaMask/faq/blob/master/DEVELOPERS.md
    this.userTimerID = setTimeout(
      () => this.checkUserAccount(),
      MILLISECONDS_IN_A_SECOND
    );
  }

  clearUserTimer() {
    if (this.userTimerID) {
      clearTimeout(this.userTimerID);
    }
  }

  checkForProvider() {
    if (window.ethereum || window.web3) {
      Log.info('Injected web3/ethereum provider detected. Refreshing page to avoid issues with MetaMask injection.');

      this.props.fetchWeb3().then(web3 => {
        initContract(web3);

        if (this.isSupportedProvider()) {
          setTimeout(
            () => window.location.reload(),
            MILLISECONDS_IN_A_SECOND
          );
        }
      });
    } else {
      this.setProviderTimer();
    }
  }

  setProviderTimer() {
    this.providerTimerID = setTimeout(
      () => this.checkForProvider(),
      MILLISECONDS_IN_A_SECOND
    );
  }

  clearProviderTimer() {
    if (this.providerTimerID) {
      clearTimeout(this.providerTimerID);
    }
  }

  componentDidMount() {
    this.props.fetchWeb3().then(web3 => {
      initContract(web3);

      // Check if a supported provider is installed
      if (this.isSupportedProvider()) {
        this.checkUserAccount();
      } else {
        if (web3.currentProvider) { // Is provider
          this.props.setStatus(STATUSES.FALLBACK);
        } else {
          this.props.setStatus(STATUSES.UNKNOWN);
        }

        this.setProviderTimer();
      }
    });
  }

  componentWillUnmount() {
    this.clearUserTimer();
  }

  render() {
    switch (this.props.status) {
      case STATUSES.AVAILABLE: // Logged in
      case STATUSES.LOCKED: // Logged out
      case STATUSES.FALLBACK: // No MetaMask
      case STATUSES.UNKNOWN: // No Provider
        return this.props.children;
      default: // null
    }

    return null;
  }
}

const mapStateToProps = state => {
  return {
    web3: state.web3Reducer.web3,
    myWalletAddress: state.web3Reducer.myWalletAddress,
    status: state.web3Reducer.status
  }
}

const mapDispatchToProps = {
  fetchWeb3,
  setMyWalletAddress,
  setStatus
}

export default connect(mapStateToProps, mapDispatchToProps)(Web3Provider);



// WEBPACK FOOTER //
// ./src/components/Web3Provider.js